import React, {ReactNode} from 'react';
import Page, {PageType} from '@episerver/spa-core/Page';
import CellcomRedirectPageData from '../../Models/Content/CellcomRedirectPageData';
import LocalLoader from '../Shared/LocalLoader/LocalLoader';

export default class CellcomRedirectPage extends Page<CellcomRedirectPageData> {
  protected pageType = PageType.Other;

  public componentWillMount() {
    const redirectToPageUrl = this.props.data.redirectToPageUrl?.value;
    window.location.replace(redirectToPageUrl);
  }

  public render(): ReactNode | null {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    return (
      <div style={{marginTop: '100px', marginBottom: '100px'}}>
        <LocalLoader />
      </div>
    );
  }
}
